export const ManualAccountGuideSteps = {
  selectInstitution: 1,
  setBalance: 2,
  addTransaction: 3,
} as const;

export const ManualAccountGuideTotalSteps = Object.keys(ManualAccountGuideSteps).length;

export const GuideTitleEnum: Record<string, string> = {
  welcomeBonus: "welcomeBonus",
  explorePlugin: "explorePlugin",
  viewYourCredits: "viewYourCredits",
  watchAdsToEarn: "watchAdsToEarn",
  addManualAccount: "addManualAccount",
  fetchAnAccount: "fetchAnAccount",
};
